export default __webpack_public_path__ + "static/media/BMMF-BG.3c271dad.webp";